import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBellOutlined(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.667 12a2.667 2.667 0 1 1-5.334 0m6.998-5.56.116 2.295a2 2 0 0 0 .22.816l.758 1.471a.67.67 0 0 1-.596.978H3.171a.67.67 0 0 1-.596-.978l.758-1.471a2 2 0 0 0 .22-.816l.116-2.296A4.33 4.33 0 0 1 8 2.333a4.33 4.33 0 0 1 4.331 4.106Z"
      />
    </svg>
  );
}

const ForwardRef = forwardRef(SvgBellOutlined);
export default ForwardRef;
